export default __webpack_public_path__ + "static/media/ranes14.e6737665.jpg";